import { Typography } from '@mui/material';
import { default as MenuItem } from '@mui/material/MenuItem';
import { SxProps } from '@mui/system/styleFunctionSx';

interface Props {
  label: string;
  icon?: React.ReactElement;
  variant?: 'body1' | 'button';
  color?: string;
  sx?: SxProps;
  testId?: string;
  onClick: () => void;
}

export const MenuButton = ({
  color,
  sx,
  label,
  icon,
  variant = 'body1',
  onClick,
  testId = 'menu-button'
}: Props) => {
  return (
    <MenuItem data-testid={testId} onClick={onClick} sx={sx}>
      {icon}
      <Typography variant={variant} color={color}>
        {label}
      </Typography>
    </MenuItem>
  );
};
